<!-- NEW wrapper to control scrolling -->
<div class="scheduled-notifications-page">
  <!-- Header row (count + filters) -->
  <div class="notification-history-search-box p-md divider bottom p-b-sm p-t-sm sticky-header">
    <div class="inline-block">
      @if (filterInput?.filterType) {
      <span class="font-size-16 m-b-sm">
        {{ filteredNotificationsResponse?.length }} scheduled notification
        @if (filterInput?.filterType === 'FROM') {
        <span>
          between {{ filterInput?.startDate | dateFormat : 'flight' }} and
          {{ filterInput?.endDate | dateFormat : 'flight' }}
        </span>
        }
        @if (filterInput?.filterType !== 'FROM') {
        <span>
          @if (filterInput?.filterType === 'CREATED_BY') { by {{ filterInput?.selectedAutoCompleteValue }} }
          @else { on {{ filterInput?.startDate | dateFormat : 'flight' }} }
        </span>
        }
      </span>
      } @else {
      <span class="font-size-16 m-b-sm">{{ notificationsResponse?.length }} scheduled notifications</span>
      }
    </div>

    <div class="notification-filter-slot">
      @if (createdByUsersList?.length) {
      <div class="button-border notification-filter">
        <app-filter [filterInput]="filterInput" (appliedDateFilter)="appliedDateFilter($event)"
          [displayFilter]="showFilter" [searchableOptions]="createdByUsersList"
          (clearFilter)="resetToDefault()"></app-filter>
      </div>
      } @else {

      <div class="notification-filter--placeholder"></div>
      }
    </div>
  </div>

  <div class="scheduled-notifications-scroll h-com-list">
    @if (hideSpinner) {
    <div>
      @if (displayErrorMessage) {
      <div>
        <p class="background-white m-t-xs text-center">
          <span class="m-l-lg">
            <error-message></error-message>
          </span>
        </p>
      </div>
      }
      @for (history of filteredNotificationsResponse; track history; let i = $index) {
      <div class="border-bottom-grey p-md position-relative">
        @if (!history?.editMode) {
        <div>
          <div class="position-absolute right-0">
            <button matTooltip="Edit" matTooltipPosition="above" mat-icon-button color="primary"
              (click)="editNotification(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button matTooltip="Delete" matTooltipPosition="above" mat-icon-button color="primary"
              (click)="deleteNotification(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          @if (history?.message?.alertBody !== null) {
          <div>
            <label class="history-text-label text-shade-gray font-size-15">Alert</label>
            <p class="history-text-head m-t-lg m-b-sm font-size-16 overflow-wrap-break-word">
              {{history?.message?.alertBody}}
            </p>
          </div>
          }
          @if (history?.message?.notificationBody !== null) {
          <div>
            <label class="history-text-label text-shade-gray m-t-xl font-size-15">Announcement</label>
            <p class="history-text-head m-t-lg m-b-sm font-size-16 font-weight-bold overflow-wrap-break-word">
              {{ history?.message?.msgTitle }}
            </p>
            <p class="history-text-head m-t-lg m-b-sm overflow-wrap-break-word"
              [innerHTML]="sanitizedHtml(history?.message?.notificationBody)">
            </p>
          </div>
          }
          <div class="display-flex-box m-t-xl">
            <div class="display-flex center-flex m-b-sm">
              <div class="display-flex center-flex child-50">
                <label class="history-text-label text-shade-gray">Scheduled</label>
                <div class="m-l-md">
                  <span><img src="assets/icons/date-table.svg" alt=""></span>
                  <div class="inline-block">
                    <span class="m-l-sm font-size-15 pull-left">
                      {{history?.scheduleDateTime | dateFormat : 'overviewdate'}}
                    </span>
                  </div>
                </div>
                <div class="m-l-md">
                  <img src="assets/icons/time-table.svg" alt="">
                  <div class="inline-block">
                    <span class="m-l-sm font-size-15 pull-left">{{history?.scheduleDateTime | timeFormat }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="display-flex center-flex child-50 m-t-xl">
              <label class="history-text-label text-shade-gray">Created by</label>
              <div class="font-size-14 m-l-md">{{history?.message?.createdBy}}</div>
            </div>
            <div class="display-flex center-flex m-b-sm m-t-xl">
              <div class="display-flex center-flex child-50">
                <label class="history-text-label text-shade-gray">Category</label>
                <div class="chip font-size-14">{{history?.category | titlecase}}</div>
                @if (!history?.allUsers) {
                <div class="schedule-info">
                  <span class="icon">👤</span> Scheduled for <strong>selected users</strong>
                </div>
                } @else {
                <div class="schedule-info">
                  <span class="icon">🌐</span> Scheduled for <strong>all users</strong>
                </div>
                }
              </div>
              <div class="display-flex center-flex child-50 position-absolute right-15 text-cyan-blue cursor-pointer">
                <div (click)="toggleRecipentsAttribute(i)">
                  @if (history?.showAttributes) { <span> Hide recipients attributes </span> }
                  @else { <span> Show recipients attributes </span> }
                </div>
              </div>
            </div>
          </div>
          @if (history?.showAttributes) {
          <div catvaluesselected class="border">
            <div class="category-container">
              @if (history?.displaySpinner) {
              <div class="m-sm">
                <div class="m-t-lg text-center">
                  <mat-spinner [diameter]="50" class="margin-auto"></mat-spinner>
                </div>
              </div>
              } @else {
              @for (attr of history?.recipentsAttribute; track attr) {
              <div class="m-sm">
                <div
                  class="background-color-solitude border-radius-16 category-item p-t-sm p-r-sm p-b-sm p-l-sm w-fit-content">
                  <div>
                    <div class="category-item-overflow textbluesmall">{{ attr?.name | titlecase }}</div>
                    @if (history?.category !== 'Program' && history?.category !== 'Guest' && history?.category !==
                    'email')
                    {
                    <div>
                      @if (attr?.dtStart) {
                      <div class="category-item-overflow textbluesmall">
                        <span class="text-gray-light">
                          {{ attr?.dtStart | dateFormat : 'mm/dd/yyyy' }} • {{ attr?.dtStart | timeFormat }}
                          @if (attr?.dtEnd) { - {{ attr?.dtEnd | timeFormat }} }
                          @if (attr?.id && history?.displayId) { • {{ attr?.id }} }
                        </span>
                      </div>
                      }
                    </div>
                    } @else {
                    @if (attr?.dtStart) {
                    <div class="category-item-overflow textbluesmall">
                      <span class="text-gray-light">
                        {{ attr?.dtStart | dateFormat : 'mm/dd/yyyy' }}
                        @if (attr?.dtEnd && history?.category !== 'email') {
                        - {{ attr?.dtEnd | dateFormat : 'mm/dd/yyyy' }}
                        }
                      </span>
                    </div>
                    }
                    }
                  </div>
                </div>
              </div>
              }
              }
            </div>
          </div>
          }
        </div>
        } @else {
        <!-- EDIT MODE (aligned like old) -->
        <div class="edit-notification edit-shell">
          <div class="edit-header">
            <div class="edit-header__left">
              <div class="edit-action">
                @if (history?.message?.alertBody !== null) {
                <button matTooltip="Remove Alert" matTooltipPosition="above" mat-icon-button color="primary"
                  [disabled]="history?.message?.messageType !== '3'"
                  (click)="addRemoveToExistingNotification(i, true, true)">
                  <mat-icon>highlight_off</mat-icon>
                </button>
                <span>Remove Alert</span>
                } @else {
                <button matTooltip="Add Alert" matTooltipPosition="above" mat-icon-button color="primary"
                  (click)="addRemoveToExistingNotification(i, true, false)">
                  <mat-icon>add_circle_outline</mat-icon>
                </button>
                <span>Add Alert</span>
                }
              </div>
              <div class="edit-action">
                @if (history?.message?.notificationBody !== null) {
                <button matTooltip="Remove Announcement" matTooltipPosition="above" mat-icon-button color="primary"
                  [disabled]="history?.message?.messageType !== '3'"
                  (click)="addRemoveToExistingNotification(i, false, true)">
                  <mat-icon>highlight_off</mat-icon>
                </button>
                <span>Remove Announcement</span>
                } @else {
                <button matTooltip="Add Announcement" matTooltipPosition="above" mat-icon-button color="primary"
                  (click)="addRemoveToExistingNotification(i, false, false)">
                  <mat-icon>add_circle_outline</mat-icon>
                </button>
                <span>Add Announcement</span>
                }
              </div>
            </div>
            <div class="edit-header__right">
              <button matTooltip="Cancel" matTooltipPosition="above" mat-icon-button color="warn"
                (click)="editNotificationCancel(i)">
                <mat-icon>close</mat-icon>
              </button>
              <button matTooltip="Save" matTooltipPosition="above" mat-icon-button class="text-green"
                (click)="updateNotification(i)" [disabled]="
                    (history?.isNotFutureDated || (history?.message?.messageType === '1'
                      ? (history?.message?.alertBody && history?.message?.alertBody === _filteredNotificationsResponse[i]?.message?.alertBody)
                      : history?.message?.messageType === '2'
                        ? (history?.message?.msgTitle && history?.message?.notificationBody &&
                          history?.message?.msgTitle === _filteredNotificationsResponse[i]?.message?.msgTitle &&
                          history?.message?.notificationBody === _filteredNotificationsResponse[i]?.message?.notificationBody)
                        : ((history?.message?.alertBody && history?.message?.alertBody === _filteredNotificationsResponse[i]?.message?.alertBody) &&
                          history?.message?.msgTitle && history?.message?.notificationBody &&
                          history?.message?.msgTitle === _filteredNotificationsResponse[i]?.message?.msgTitle &&
                          history?.message?.notificationBody === _filteredNotificationsResponse[i]?.message?.notificationBody)) &&
                      (history?.scheduleDate ===  _filteredNotificationsResponse[i]?.scheduleDate) &&
                      (history?.scheduleTime ===  _filteredNotificationsResponse[i]?.scheduleTime) &&
                      (history?.message?.messageType === _filteredNotificationsResponse[i]?.message?.messageType))">
                <mat-icon>done</mat-icon>
              </button>
            </div>
          </div>
          @if (history?.message?.alertBody !== null) {
          <div class="edit-block">
            <div class="panel-row">
              <div class="textgreysmall">Alert Body <span class="required">*</span></div>
              <div class="textgreysmall">{{ history?.message?.alertBody?.length }} / 150</div>
            </div>
            <div class="panel-row">
              <textarea class="textarea jp-textarea-body panel-row-textgreysmall" rows="1" name="alert" id="alertBody"
                maxlength="150" cols="50" [(ngModel)]="history.message.alertBody" placeholder="Add message"></textarea>
            </div>
          </div>
          }
          @if (history?.message?.notificationBody !== null) {
          <div class="edit-announcement__message edit-block">
            <div class="panel-row">
              <div class="textgreysmall">Announcement Title <span class="required">*</span></div>
              <div class="textgreysmall">{{history?.message?.msgTitle?.length}} / 50</div>
            </div>
            <div class="panel-row">
              <textarea class="textarea m-b-sm panel-row-textgreysmall" rows="1" cols="50" name="announceTitle"
                id="announceTitle" placeholder="Add title" maxlength="50"
                [(ngModel)]="history.message.msgTitle"></textarea>
            </div>
            <div class="panel-row">
              <div class="textgreysmall">Announcement Body <span class="required">*</span></div>
              <div class="textgreysmall">{{characterCount}} / {{maxCharacters}}</div>
            </div>
            <div class="panel-row flex-direction-announce">
              <ngx-editor-menu class="rich-text-tool" [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <form class="panel-row-textgreysmall" [formGroup]="form">
                <ngx-editor formControlName="content" (ngModelChange)="onContentChange($event)" [editor]="editor"
                  (keydown)="wordCounter($event)" [(ngModel)]="history.message.notificationBody" [disabled]="false"
                  [placeholder]="'Add message'">
                </ngx-editor>
              </form>
            </div>
          </div>
          }
          <!-- Scheduled row aligned like old -->
          <div class="scheduled-edit-row">
            <label class="history-text-label text-shade-gray scheduled-edit-row__label">Scheduled</label>
            <div class="scheduled-edit-row__controls">
              <mat-form-field floatLabel="always" class="date-field legacy-like-field">
                <input matInput [matDatepicker]="picker" [(ngModel)]="history.scheduleDate" [min]="minDate"
                  readonly (click)="picker.open()" (ngModelChange)="sendDateChange(i)">
                <mat-datepicker-toggle matSuffix [for]="picker" class="blue-color"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <div class="time-field-wrap">
                <mat-form-field appearance="fill" class="time-field legacy-like-field"
                  (click)="displaySendTimePicker = !displaySendTimePicker" [floatLabel]="'never'">
                  <input matInput name="one-time-time" value="{{history?.scheduleTime | dateFormat :'missedAddedTime'}}"
                    placeholder="00:00" autocomplete="off" readonly>
                  <mat-icon class="time-icon blue-color">access_time</mat-icon>
                </mat-form-field>
                @if (displaySendTimePicker) {
                <app-time-picker [dateTime]="history?.scheduleTime" (cancel)="displaySendTimePicker=false"
                  (update)="sendTimeChange($event, i)" [minutesArr]="minuteIntervalArr" class="sendTimePicker">
                </app-time-picker>
                }
              </div>
            </div>
          </div>
          @if (history?.isNotFutureDated) {
          <div class="history-text-label m-t-sm">Please select a future date and/or time</div>
          }
        </div>
        }
      </div>
      }
    </div>
    } @else {
    <div class="m-t-lg">
      <mat-spinner [diameter]="50" class="margin-auto"></mat-spinner>
    </div>
    }
  </div>
</div>